import { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "./context/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { auth } = useContext(AuthContext);
    return auth ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
